import { ServiceClient } from 'src/utils'
import type { Painel } from './overview_scopes'

const serviceClient = ServiceClient.singleton()

export class OverviewService {
    static #INSTANCE = new OverviewService()
    static readonly singleton = () => OverviewService.#INSTANCE

    async painel(): Promise<Painel> {
        return serviceClient.authGet<Painel>('/api/painel')
    }
}

export default OverviewService.singleton()
